module.exports = __webpack_public_path__ + "img/option_three.5f971686.png";